import { useQuery } from "@tanstack/react-query";
import { FirestoreError } from "firebase/firestore";
import { useParams } from "react-router-dom";
import { QUERY_KEY } from "@/modules/projetos/components/projetos-table/ProjetosTable";
import { getProjetosItem } from "@/modules/projetos/firestore";
import useUserStore from "@/modules/users/store";

type TGetProjetoResponse = Awaited<ReturnType<typeof getProjetosItem>>;

/**
 * Get projeto from url params
 * @param idProjeto - id do projeto
 * @param idProjeto.idProjeto - id do projeto
 * @param idProjeto.empresaConvidada - empresa convidada
 * @returns - projeto or null if not found
 */
// prettier-ignore
function useGetProjetoItem({ idProjeto, empresaConvidada }: { idProjeto: TProjeto["id"] | undefined, empresaConvidada: boolean }) {
  const { idEmpresa } = useParams<{ idEmpresa: string }>();
  const activeEmpresaId = useUserStore((state) => state.activeEmpresaId);
  const verify = empresaConvidada ? idEmpresa : activeEmpresaId;

  return useQuery<TGetProjetoResponse, FirestoreError, TProjeto | null>({
    queryKey: [QUERY_KEY, idProjeto, verify],
    queryFn() {
      if (!verify) {
        throw new Error("Empresa não selecionada");
      }
      if (!idProjeto) {
        throw new Error("Ideia não selecionada");
      }

      return getProjetosItem(verify, idProjeto);
    },
    select(dataResponse) {
      if (!dataResponse.exists()) {
        return null;
      }

      return dataResponse.data();
    },
    enabled: !!idProjeto && !!verify
  });
}

export default useGetProjetoItem;
